import { render, staticRenderFns } from "./ed-homeworks-container.vue?vue&type=template&id=7753f374&scoped=true&"
import script from "./ed-homeworks-container.ts?vue&type=script&lang=ts&"
export * from "./ed-homeworks-container.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homeworks-container.scss?vue&type=style&index=0&id=7753f374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7753f374",
  null
  
)

export default component.exports